@if(!open_mx_popup){
<div class="dialog-container-W750-H600" [ngClass]="inlineComponent ? 'custom-inline-component' : ''">
  @if(!inlineComponent){
  <div class="mb-3 flex justify-between">
    <p class="text-2xl font-bold" style="margin: 0px; position: relative; text-align: center; width: -webkit-fill-available; left: 12px">
      Manage {{ data.label }}
    </p>

    <button type="button" class="close add-close-button" style="position: relative; top: -6px" data-dismiss="modal" (click)="closeDialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>

  } @if (!is_unLinkedFileLoading && !is_LinkedFileLoading) {
  <div [ngClass]="inlineComponent ? 'h-full' : 'h-[82%]'">
    @if(isFromLinkedTemplate){
    <p class="font-bold text-[#010B18] mb-4 text-base">{{ data.label }}</p>
    }
    <div style="margin-right: -20px; padding-right: 12px" [ngClass]="{ 'm-0 p-0': isFromLinkedTemplate }">
      @if (this.data?.label != 'Items In This Location') {
      <manage-templates
        [hub_vault_user_form_id]="data.currentFormId"
        [origin]="data.origin"
        [data]="unlinkedTemplate"
        [placeHolder]="isFromLinkedTemplate ? 'Search templates' : textBoxPlaceHolder"
        [allowedOne]="allowedOne"
        (selectionChange)="selectConnectedUser($event)"
        [selectedTemplate]="linkedTemplate"
        [isShowFooter]="data?.isCapitalCommitment ? false : true"
        [templateConfigurationList]="is_Group ? group_templateConfigurationList : templateConfigurationList"
        [isFromLinkedTemplate]="isFromLinkedTemplate"
        [disableSearch]="isRemoveEditSaveSharing"
      ></manage-templates>
      }
    </div>
    <div>
      @if (this.data?.label == 'Items In This Location') {
      <manage-combo-element
        #manageComboElement
        [isInputFullWidth]="true"
        [placeHolder]="textBoxPlaceHolder"
        [filterConfiguration]="filterConfiguration"
        [hub_vault_user_form_id]="data.vault_user_form_id"
        (selectionChange)="handleSelectedUser($event)"
        [inlineComponent]="inlineComponent"
        [disableSearch]="isRemoveEditSaveSharing"
      >
      </manage-combo-element>
      }
    </div>
    <div #commonSuggestionViewContainer [ngClass]="{ 'overflow-content': isEditLinkFile }">
      <div
        [ngClass]="{ 'max-h-[50%]': inlineComponent, 'p-0 h-full': isFromLinkedTemplate }"
        [style.height.px]="
          suggestionData?.length > 1 && suggestionData[1].vaultFormTypeData?.length
            ? linkedTemplate.length
              ? isEditLinkFile
                ? 'auto'
                : '180px'
              : 'auto'
            : '380'
        "
        [style.max-height]="suggestionData?.length > 1 && suggestionData[1].vaultFormTypeData?.length ? (isEditLinkFile ? 'auto' : '180px') : '380px'"
        style="overflow: auto; padding-right: 12px"
      >
        @if (!is_unLinkedFileLoading && !is_LinkedFileLoading) {
        <linked-template-list
          (deleteTemplate)="deleteTemplate($event)"
          (viewTemplate)="viewModal($event)"
          (connectTemplateFeedData)="editFeedData($event)"
          (reConnectTemplateFeedData)="reconnect($event)"
          [linkedTemplate]="linkedTemplate"
          [title]="title_type"
          [data]="data"
          [isFromLinkedTemplate]="isFromLinkedTemplate"
          [hideTitle]="isFromLinkedTemplate"
          [hideCheckbox]="isRemoveEditSaveSharing ? true : hideCheckbox"
          [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
          (linkedTemplateSelectionChange)="onLinkedTemplateSelectionChange($event)"
        >
        </linked-template-list>
        }
      </div>
      @if(!isFromLinkedTemplate){ @if (suggestionData?.length>1 && suggestionData[1].vaultFormTypeData?.length) {
      <div
        style="margin-top: 12px; margin-bottom: 20px; padding-right: 12px; overflow: auto"
        [style.height.px]="isEditLinkFile ? 'auto' : '180px'"
        [style.max-height]="isEditLinkFile ? 'auto' : '180px'"
      >
        @if (!is_unLinkedFileLoading && !is_LinkedFileLoading) {
        <common-suggestion-view
          [source]="null"
          [origin]="data.origin"
          [type]="data.type"
          [title]="title"
          (addMXEventEmitter)="addMXEventEmitter($event)"
          (selectItemEventEmitter)="selectItemEventEmitter($event)"
          [vaultUserFormId]="data.currentFormId"
          [suggestionData]="suggestionData"
          [selectedData]="linkedTemplate"
        >
        </common-suggestion-view>
        }
      </div>
      }}
    </div>
  </div>
  } @if (is_unLinkedFileLoading || is_LinkedFileLoading) { @if(!isFromLinkedTemplate){
  <div class="loader-container h-[460px]" style="flex-direction: column">
    @for (item of loadingItems; track item) {
    <div>
      <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
        <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
          <div class="ph-col-12" style="padding: 0px !important">
            <div class="ph-row">
              <div class="ph-col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }@else {
  <div class="ph-item width-100per loader-body-item" style="padding: 0px; border: 0px">
    <div class="ph-col-12" style="padding: 0px !important">
      <div class="ph-row" style="margin: 12px">
        <div class="ph-col-4"></div>
        <div class="ph-col-6 empty"></div>
        <div class="ph-col-2"></div>
      </div>
    </div>
  </div>
  } } @if(!inlineComponent){ @if (!hideMarkForCheck &&!linkedLocation && (suggestionData?.length>1 && suggestionData[1].vaultFormTypeData?.length)) {
  <div class="action" style="text-align: start; border-top: 1px solid #d3dce8; margin: 12px -18px 0px -18px">
    <form class="text-center" [formGroup]="myForm">
      <mat-slide-toggle
        formControlName="name"
        style="margin: 18px 18px 0px 18px"
        class="font-normal text-sm margin-zero"
        [ngClass]="{
          'text-[#515765]': !isRemoveEditSaveSharing,
          'text-[#C1C2C5]': isRemoveEditSaveSharing
        }"
        [disabled]="isRemoveEditSaveSharing"
        (change)="onToggleChange($event)"
      >
        Mark {{ data.label | titlecase }} as complete
      </mat-slide-toggle>
    </form>
  </div>
  } }
</div>
}
